<template>
  <div
    class="tooth"
    v-click-outside="onCloseMenu">
    <tooth-popover-menu v-bind:value="isShowMenu">
      <template slot="trigger">
        <div class="tooth__body">
          <button
            class="tooth__body__bone"
            type="button"
            v-bind:class="{ selected: isSelected('bone') }"
            v-bind:style="{ 'background-color': partColor['bone'] || '#ffead2' }"
            v-on:click="onClick('bone', $event)" />
          <button
            class="tooth__body__gingiva"
            type="button"
            v-bind:class="{ selected: isSelected('gingiva') }"
            v-bind:style="{ 'background-color': partColor['gingiva'] || '#f4ddc1' }"
            v-on:click="onClick('gingiva', $event)" />
          <button
            class="tooth__body__all-tooth"
            type="button"
            v-on:click="onAllToothClick($event)" />
          <svg
            v-if="!isDeleted"
            class="tooth-up-3 tooth__parts"
            v-bind:class="{ flip }"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 68 179">
            <g v-if="isDiagnosisImplant" id="implant">
              <rect width="25.564" height="13.231" x=".5" y="-.5" fill="#A8BEC5" stroke="#778F9F" rx="1.397" transform="matrix(1 0 0 -1 22.867 74.264)" />
              <path fill="#778F9F" stroke="#778F9F" stroke-width=".949" d="M46.566 57.673H25.733L30.57 1.896h11.905l4.092 55.777Z" />
              <rect width="29.845" height="4.309" x="21.227" y="57.199" fill="#A8BEC5" stroke="#778F9F" stroke-width=".949" rx="1.146" />
              <path fill="#A8BEC5" stroke="#778F9F" stroke-linecap="round" stroke-width=".949" d="M23.07 53.015a1.68 1.68 0 0 0 1.939 1.372l23.52-4.032.168-.037a1.68 1.68 0 0 0-.736-3.274l-23.52 4.032a1.68 1.68 0 0 0-1.371 1.939Zm2.433-5.267.17-.019 22.177-3.697a1.68 1.68 0 1 0-.552-3.314L25.12 44.414l-.167.037a1.68 1.68 0 0 0 .549 3.297Zm.339-6.325.172-.02 21.84-3.696a1.68 1.68 0 0 0-.56-3.313L25.451 38.09l-.167.037a1.681 1.681 0 0 0 .557 3.296Zm-.758-7.729a1.68 1.68 0 0 0 1.929 1.386l20.496-3.36a1.68 1.68 0 0 0-.544-3.315l-20.495 3.36a1.68 1.68 0 0 0-1.386 1.93Zm2.142-4.924.17-.024 19.152-3.696a1.68 1.68 0 0 0-.636-3.3l-19.153 3.697-.167.041a1.68 1.68 0 0 0 .634 3.282Zm.67-5.989.17-.024 17.473-3.36.167-.04a1.68 1.68 0 0 0-.802-3.26l-17.472 3.36-.167.041a1.68 1.68 0 0 0 .631 3.283Zm.295-6.658.17-.019 16.129-2.689a1.68 1.68 0 1 0-.553-3.314L27.81 12.79l-.167.037a1.68 1.68 0 0 0 .549 3.297Zm.389-6.329.171-.025 15.12-3.024.167-.042a1.68 1.68 0 0 0-.826-3.253l-15.12 3.024-.167.042a1.681 1.681 0 0 0 .656 3.278Z" />
            </g>
            <g v-else>
              <path
                d="M47.1077 68.7279H47.1078C46.4137 59.6238 44.8173 39.2142 43.9844 30.4079C42.9433 19.4 35.1413 7.14589 32.6426 3.5112C30.1439 -0.123482 25.667 -0.538879 26.7081 6.5228C27.7493 13.5845 28.6797 27.7078 28.2632 31.5502C27.8468 35.3926 25.8686 46.8159 25.3481 49.2044C24.9316 51.1152 24.0768 63.1547 23.7014 68.9355C34.6409 68.7279 40.0819 68.7279 47.1077 68.7279Z"
                v-bind:class="{ selected: isSelected('root_1') }"
                v-bind:fill="partColor['root_1'] || '#FFF'"
                v-on:click="onClick('root_1', $event)"
                v-on:keydown="onClick('root_1', $event)" />
              <path
                d="M37.6469 53.7536L38.6222 53.5046C39.0429 53.3971 39.4233 53.1693 39.7166 52.8491C40.2725 52.2424 40.4707 51.3918 40.2581 50.5968C36.3716 36.0609 35.9968 17.5888 35.0332 14.0974C35.001 13.9808 34.9443 13.8851 34.8675 13.7916C34.5707 13.4306 34.0186 13.4009 33.7216 13.7618C33.6201 13.8852 33.5469 13.9884 33.5484 14.0282C34.0427 27.1493 32.7762 44.1223 30.9342 51.5952L30.7918 52.2197C30.682 52.7012 30.8304 53.205 31.1837 53.5501C31.3871 53.7489 31.6456 53.8819 31.9256 53.9319L32.7464 54.0785L34.1918 54.1358L35.6066 54.042L37.6469 53.7536Z"
                v-bind:class="{ selected: isSelected('central_canal') }"
                v-bind:fill="partColor['central_canal'] || '#FF82BE'"
                v-on:click="onClick('central_canal', $event)"
                v-on:keydown="onClick('central_canal', $event)" />
            </g>
            <path
              v-if="!isDiagnosisImplant || hasCrownOnImplant"
              d="M45.137 89.602c-3.998 4.154-7.92 5.573-9.793 5.608a14.44 14.44 0 0 1-.774-.224c-9.969-3.2-15.47-16.646-10.868-26.05.467-.952 2.372-4.8 3.007-5.711 4.748-6.813 11.001-5.954 13.535-4.673 1.492.9 4.997 5.503 6.865 10.177 1.494 3.738 2.435 8.896 2.192 11.215-.104 1.558-.166 5.504-4.164 9.658Z"
              v-bind:class="{ selected: isSelected('crown') }"
              v-bind:fill="partColor['crown'] || '#FFF'"
              v-on:click="onClick('crown', $event)"
              v-on:keydown="onClick('crown', $event)" />
          </svg>
          <svg
            v-else-if="isBoneImplant"
            class="tooth-up-3 tooth__parts"
            v-bind:class="{ flip }"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 68 179">
            <g id="implant">
              <rect width="25.564" height="13.231" x=".5" y="-.5" fill="#A8BEC5" stroke="#778F9F" rx="1.397" transform="matrix(1 0 0 -1 22.867 74.264)" />
              <path fill="#778F9F" stroke="#778F9F" stroke-width=".949" d="M46.566 57.673H25.733L30.57 1.896h11.905l4.092 55.777Z" />
              <rect width="29.845" height="4.309" x="21.227" y="57.199" fill="#A8BEC5" stroke="#778F9F" stroke-width=".949" rx="1.146" />
              <path fill="#A8BEC5" stroke="#778F9F" stroke-linecap="round" stroke-width=".949" d="M23.07 53.015a1.68 1.68 0 0 0 1.939 1.372l23.52-4.032.168-.037a1.68 1.68 0 0 0-.736-3.274l-23.52 4.032a1.68 1.68 0 0 0-1.371 1.939Zm2.433-5.267.17-.019 22.177-3.697a1.68 1.68 0 1 0-.552-3.314L25.12 44.414l-.167.037a1.68 1.68 0 0 0 .549 3.297Zm.339-6.325.172-.02 21.84-3.696a1.68 1.68 0 0 0-.56-3.313L25.451 38.09l-.167.037a1.681 1.681 0 0 0 .557 3.296Zm-.758-7.729a1.68 1.68 0 0 0 1.929 1.386l20.496-3.36a1.68 1.68 0 0 0-.544-3.315l-20.495 3.36a1.68 1.68 0 0 0-1.386 1.93Zm2.142-4.924.17-.024 19.152-3.696a1.68 1.68 0 0 0-.636-3.3l-19.153 3.697-.167.041a1.68 1.68 0 0 0 .634 3.282Zm.67-5.989.17-.024 17.473-3.36.167-.04a1.68 1.68 0 0 0-.802-3.26l-17.472 3.36-.167.041a1.68 1.68 0 0 0 .631 3.283Zm.295-6.658.17-.019 16.129-2.689a1.68 1.68 0 1 0-.553-3.314L27.81 12.79l-.167.037a1.68 1.68 0 0 0 .549 3.297Zm.389-6.329.171-.025 15.12-3.024.167-.042a1.68 1.68 0 0 0-.826-3.253l-15.12 3.024-.167.042a1.681 1.681 0 0 0 .656 3.278Z" />
            </g>
            <path
              v-if="hasCrownOnImplant"
              d="M45.137 89.602c-3.998 4.154-7.92 5.573-9.793 5.608a14.44 14.44 0 0 1-.774-.224c-9.969-3.2-15.47-16.646-10.868-26.05.467-.952 2.372-4.8 3.007-5.711 4.748-6.813 11.001-5.954 13.535-4.673 1.492.9 4.997 5.503 6.865 10.177 1.494 3.738 2.435 8.896 2.192 11.215-.104 1.558-.166 5.504-4.164 9.658Z"
              v-bind:class="{ selected: isSelected('crown') }"
              v-bind:fill="partColor['crown'] || '#FFF'"
              v-on:click="onClick('crown', $event)"
              v-on:keydown="onClick('crown', $event)" />
          </svg>
        </div>
      </template>
      <form-teeth-formula-diagnoses
        v-bind:class="{ 'disable-component': disabled }"
        v-bind:is-deleted="needDeleted"
        v-bind:part-list="partList"
        v-bind:has-implant="hasImplant"
        v-on:cancel="onCloseMenu"
        v-on:change-diagnoses="onChangeDiagnoses"
        v-on:change-tooth-deleted="onChangeToothDeleted"
        v-on:submit="onSubmit" />
    </tooth-popover-menu>
    <top-tooth-surface
      v-bind:surface="surface"
      v-bind:part-selected="partSelected"
      v-bind:selected-parts="selectedParts"
      v-on:select="onClick" />
    <div class="tooth__number">{{ tooth.number }}</div>
  </div>
</template>
<script>
import toothMixin from '@/mixins/toothMixin';
import TopToothSurface from '../TopToothSurface.vue';
import FormTeethFormulaDiagnoses from '../FormTeethFormulaDiagnoses.vue';
import ToothPopoverMenu from '../ToothPopoverMenu.vue';

export default {
  components: {
    TopToothSurface,
    FormTeethFormulaDiagnoses,
    ToothPopoverMenu,
  },
  mixins: [toothMixin],
  name: 'ToothUp3',
};
</script>

<style scoped></style>
